export default "__VITE_ASSET__DskzoBFF__"